import { Lock } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import typography from "../cssUtils/typography";

const NoPermission = () => {
  return (
    <Stack alignItems="center" gap={2}>
      <Lock sx={{fontSize: 80}}/>
      <Typography sx={{...typography.h1}}>
        You do not have the necessary permissions to access this feature
      </Typography>
    </Stack>
  );
};

export default NoPermission;
